import React, { useEffect, useState } from "react";
import "./pages.css";
import api from "../../utilis/api";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { online, url } from "../../utilis/contant";
import TeacherDrawer from "../../components/modals/TeacherDrawer";

const TeacherList = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedTeacherId, setExpandedTeacherId] = useState(null);

  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);

  const subscription = user?.subscription || null;

  const toggleDrawer = (teacherId) => {
    setExpandedTeacherId((prev) => (prev === teacherId ? null : teacherId));
  };

  const getTeachers = async () => {
    try {
      setLoading(true);
      const response = await api.get("/teacher");
      setTeachers(response.data.data || []);
    } catch (error) {
      console.error("Error fetching teachers:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getTeachers();
  }, []);

  // Discount calculation
  const getDiscountRate = () => {
    if (!subscription?.hasSubscription || subscription?.status !== "Active")
      return 0;
    return subscription.planType === "yearly" ? 0.2 : 0.1;
  };

  const discountRate = getDiscountRate();
  const hasActivePlan = discountRate > 0;

  const basePrices = { oneHour: 120, thirtyMin: 84 };

  const discountedPrices = {
    oneHour: Math.round(basePrices.oneHour * (1 - discountRate)),
    thirtyMin: Math.round(basePrices.thirtyMin * (1 - discountRate)),
  };

  // Handle booking - goes to confirmation page with time slot selection
  const handleBook = (e, selectedTeacher, duration) => {
    e.stopPropagation(); // Prevent row click / drawer from opening
    const price =
      duration === "60" ? discountedPrices.oneHour : discountedPrices.thirtyMin;
    const originalPrice =
      duration === "60" ? basePrices.oneHour : basePrices.thirtyMin;

    navigate("/dashboard/student/booking-confirmation", {
      state: {
        teacher: selectedTeacher,
        duration, // "30" or "60" minutes
        price,
        originalPrice,
        discountRate,
        subscriptionPlan: subscription?.planType || null,
      },
    });
  };

  const discountBadge = () => {
    if (!hasActivePlan) return null;
    const isVip = subscription.planType === "yearly";
    return (
      <span
        style={{
          background: isVip ? "#e6be5d22" : "#6366f122",
          border: `1px solid ${isVip ? "#e6be5d55" : "#6366f155"}`,
          color: isVip ? "#e6be5d" : "#818cf8",
          fontSize: "11px",
          fontWeight: 700,
          padding: "3px 10px",
          borderRadius: "20px",
          marginLeft: "8px",
        }}
      >
        {isVip ? "👑 VIP — 20% off" : "✓ Base — 10% off"}
      </span>
    );
  };

  if (loading) {
    return (
      <p style={{ color: "#888", textAlign: "center" }}>Loading teachers...</p>
    );
  }

  return (
    <div className="overview-container">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginBottom: "1.5rem",
          flexWrap: "wrap",
          gap: "0.5rem",
        }}
      >
        <h2 style={{ margin: 0 }}>Our Teachers</h2>
        {discountBadge()}
      </div>

      {/* Pricing Info Bar */}
      <div
        style={{
          background: "#1a1a1a",
          border: "1px solid #333",
          borderRadius: "10px",
          padding: "12px 16px",
          marginBottom: "1.5rem",
          display: "flex",
          gap: "2rem",
          flexWrap: "wrap",
          fontSize: "13px",
          color: "#9ca3af",
        }}
      >
        <span>
          🕐 <strong style={{ color: "#fff" }}>1 Hour</strong> —{" "}
          {hasActivePlan ? (
            <>
              <span style={{ textDecoration: "line-through", color: "#555" }}>
                ${basePrices.oneHour}
              </span>{" "}
              <span style={{ color: "#22c55e", fontWeight: 700 }}>
                ${discountedPrices.oneHour}
              </span>
            </>
          ) : (
            <span style={{ color: "#fff", fontWeight: 700 }}>
              ${basePrices.oneHour}
            </span>
          )}
        </span>

        <span>
          ⏱ <strong style={{ color: "#fff" }}>30 Minutes</strong> —{" "}
          {hasActivePlan ? (
            <>
              <span style={{ textDecoration: "line-through", color: "#555" }}>
                ${basePrices.thirtyMin}
              </span>{" "}
              <span style={{ color: "#22c55e", fontWeight: 700 }}>
                ${discountedPrices.thirtyMin}
              </span>
            </>
          ) : (
            <span style={{ color: "#fff", fontWeight: 700 }}>
              ${basePrices.thirtyMin}
            </span>
          )}
        </span>

        {!hasActivePlan && (
          <span>
            💡{" "}
            <span
              style={{ color: "#e6be5d", cursor: "pointer", fontWeight: 600 }}
              onClick={() => navigate("/membership")}
            >
              Subscribe to save up to 20%
            </span>
          </span>
        )}
      </div>

      {teachers.length > 0 ? (
        <table className="teacher-table">
          <thead>
            <tr>
              <th>Image</th>
              <th>Teacher Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Skills</th>
              <th>Book Lesson</th>
            </tr>
          </thead>
          <tbody>
            {teachers.map((t) => (
              <React.Fragment key={t._id}>
                <tr
                  className="teacher-row"
                  onClick={() => toggleDrawer(t._id)}
                  style={{ cursor: "pointer" }}
                >
                  <td>
                    <img
                      src={`${url}/${t.userId?.image || "default.jpg"}`}
                      alt={t.userId?.name}
                      className="teacher-img"
                    />
                  </td>
                  <td>{t.userId?.name}</td>
                  <td>{t.userId?.email}</td>
                  <td>{t.userId?.phone}</td>
                  <td>{t.skills}</td>

                  {/* Booking Buttons - Isolated from row click */}
                  <td onClick={(e) => e.stopPropagation()}>
                    <div
                      style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}
                    >
                      <button
                        className="dashboard-btn register-btn"
                        style={{
                          fontSize: "12px",
                          padding: "6px 12px",
                          whiteSpace: "nowrap",
                        }}
                        onClick={(e) => handleBook(e, t, "60")}
                      >
                        1 Hr — ${discountedPrices.oneHour}
                      </button>
                      <button
                        className="dashboard-btn"
                        style={{
                          fontSize: "12px",
                          padding: "6px 12px",
                          whiteSpace: "nowrap",
                          border: "1px solid #444",
                        }}
                        onClick={(e) => handleBook(e, t, "30")}
                      >
                        30 Min — ${discountedPrices.thirtyMin}
                      </button>
                    </div>
                  </td>
                </tr>

                {/* Teacher Bio Drawer */}
                {expandedTeacherId === t._id && (
                  <tr className="teacher-drawer-row">
                    <td colSpan={6}>
                      <TeacherDrawer teacher={t} />
                    </td>
                  </tr>
                )}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      ) : (
        <p style={{ color: "#888" }}>No teachers available.</p>
      )}
    </div>
  );
};

export default TeacherList;
